import { ErrorHandler, NgModule } from '@angular/core'
import Bugsnag from '@bugsnag/js'
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'
import { environment } from '@environment'


if (environment.production) {
  Bugsnag.start({
    apiKey: environment.bugsnag,
    onError: (event) => {
      const error = event.errors?.[0];
      const errorClass = error?.errorClass ?? '';
      const errorMsg = error?.errorMessage ?? '';
      const stacktrace = error?.stacktrace ?? [];
      const hasStackSource = (source: string) => stacktrace.some((frame: any) => frame?.file?.includes(source));

      // Google Identity Services internal error
      if (errorMsg === 'na' && hasStackSource('accounts.google.com/gsi/client')) {
        return false;
      }

      // Lazy-loaded chunk errors
      if (errorClass === 'ChunkLoadError' || errorMsg.includes('ChunkLoadError') || errorMsg.includes('Loading chunk')) {
        return false;
      }

      // Invalid boolean Promise rejection
      if (errorMsg === 'Uncaught (in promise): true' || errorMsg.includes('Uncaught (in promise): true')) {
        return false;
      };

      // API errors
      if (errorClass === 'HttpErrorResponse') {
        // Facebook Graph API errors
        if (errorMsg.includes('graph.facebook.com')) {
          return false;
        }
      }

      // Google reCAPTCHA timeout
      if (errorMsg.includes('reCAPTCHA Timeout') && hasStackSource('gstatic.com/recaptcha')) {
        return false;
      }

      // Microsoft Clarity internal error
      if (errorClass === 'TypeError' && errorMsg.includes("Cannot read properties of null (reading 'sequence')") && hasStackSource('scripts.clarity.ms')) {
        return false;
      }

      // Android In-App Browser / WebView native bridge error
      const isNativePostMessageError = errorMsg.includes('Error invoking postMessage') && errorMsg.includes('Java exception');
      const isIabNavigationLogger = hasStackSource('navigation_performance_logger_android') || hasStackSource('iabjs://');
      if (isNativePostMessageError || isIabNavigationLogger) {
        return false;
      }

      // invalid object where a stream was expected
      // if (errorClass === 'TypeError' && errorMsg.includes('invalid object where a stream was expected')) {
      //   return false;
      // }

      // Firebase: Error (auth/network-request-failed)
      // if (errorMsg.includes('Firebase: Error (auth/network-request-failed)')) {
      //   return false;
      // }
      return true;
    }
  });
}

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  return environment.production ? new BugsnagErrorHandler() : null;
}

@NgModule({
  providers: environment.production ? [{ provide: ErrorHandler, useFactory: errorHandlerFactory }] : []
})

export class ErrorHandlerModule { }
